<template>
 <div class="shopping-cart">
    <b-card v-for="(item,index) in items" :key="index" no-body class="mb-1">
        <b-button-toolbar id="SalesLineBtn" >
            <b-card-header header-tag="header" class="p-1" role="tab">
                <b-btn block href="#" v-b-toggle="'Acc-' + index" variant="success">
                <div id="block_container">
                        <div  id="bloc1">
                            <div>{{item.itemno + '[' + item.variant + '] ' + item.description + ' Cant.: ' + item.qty}}</div>
                            <div v-if="item.m3length > 0">{{' (' + item.m3qty + 'x' + item.m3length + 'x' + item.m3width + 'x' + item.m3height + ')'}}</div>
                        </div>
                        <div  id="bloc2">
                            <div>{{parseFloat(item.lineamount).toFixed(2) + " €"}}</div>
                            <div v-if="item.linedisc != 0" id="orig-price">{{parseFloat(item.qty * item.unitprice).toFixed(2) + " €"}}</div>
                        </div>
                        <b-btn id="delbtn" @click="delProduct(index)"><font-awesome-icon icon="trash" :style="{ color: 'white' }"/></b-btn>
                    </div>                    
                </b-btn>
            </b-card-header>             
        </b-button-toolbar>     
        <!-- <b-collapse id="item.id" visible="false" accordion="my-accordion" role="tabpanel"> -->
        <b-collapse v-bind:id="'Acc-' + index" accordion="my-accordion" role="tabpanel" visible>
            <b-card-body>
                <b-form>
                    <b-form-row>
                        <b-col>
                            <label for="LineQty">Cant.</label>
                            <b-form-input autocomplete="off" min = "0" onkeyup="if(this.value < 0){this.value = this.value * -1}" type="number" @keydown.native.enter="focusSearch" v-focus @focus.native="$event.target.select()" id="LineQty" @change="SetQty(index,$event)" v-model="item.qty" placeholder="Cant." />
                        </b-col>
                        <b-col>
                            <label for="LinePrice">Precio</label>
                            <b-form-input autocomplete="off" id="LinePrice" type="number" @change="SetQty(index,$event)" v-model="item.unitprice" placeholder="Precio"/>
                        </b-col>
                        <b-col>
                            <!-- <div>
                            <label for="LineDisc">Dto.</label>
                            <b-form-checkbox v-model="item.dtoManual" 
                            value=1
                            unchecked-value=0
                             @change="SetDtoManual(index,$event)"> Man.</b-form-checkbox> 
                            </div> --> 
                            <label for="LineDisc">Dto.</label>
                            <b-form-input :state="validateState(item.linedisc)" v-validate="'between:0,100'" name="LineDisc" id="LineDisc" type="number" @change="SetQty(index,$event)" v-model="item.linedisc" placeholder="% Dto."/>
                            <b-form-invalid-feedback id="LineDisc-live-feedback">
                                El descuento debe estar entre 0 y 100
                            </b-form-invalid-feedback>
                        </b-col>
                    </b-form-row>
                      <!--
                     <b-form-row>
                        <b-col>
                            <b-form-textarea id="textarea1"
                                v-model="item.notes"
                                    placeholder="Notas"
                                :rows="1"
                                :max-rows="6">
                            </b-form-textarea>
                        </b-col>
                    </b-form-row>
                    --> 
                </b-form>
                <b-link @click="GetAvailable(index)" align-h="start" v-bind:id="'link-location-' + index" href="#">Almacén: {{item.location}} Disp: {{item.availqty}}</b-link>
                
            </b-card-body>
        </b-collapse>
        <b-popover triggers="click blur" v-bind:target="'link-location-' + index" :placement="'bottom'" title="Cambiar almacén">
                  <b-table @row-clicked="LocationChange($event,index)" striped hover :items="Available">
                  </b-table>
                </b-popover>
    </b-card>   
  </div>   
</template>

<script>

export default {
    name: 'ShoppingCart',     
    data () {
        return {           
            Available : []    
        }
    },
    mounted: function (){
        this.$validator.localize("en")
    },
    computed: {
        items() {
            return this.$store.state.items
        }
    },    
    methods: {        
        delProduct(index) {      
            this.$store.commit('delItem', index)           
        }, 
        SetDtoManual(index,val){
            this.$store.state.items[index].dtoManual = val
            var data = this.$store.state.items[index]
            this.$store.commit('updItem', {index, data})
            if (val == 0){
                this.SetQty(index,val)
            }
        },       
        SetQty(index,val){            
            
            if (!this.$store.state.items[index].qty || this.$store.state.items[index].qty == 0)
            {
                this.$store.state.items[index].qty = 1                
            }
            
            if (!this.$store.state.items[index].linedisc || this.$store.state.items[index].linedisc > 100)
            {
                this.$store.state.items[index].linedisc = 0                
            }

            var req =  {
                custId: this.$store.state.customer.id,
                itemno: this.$store.state.items[index].itemno,
                qty: this.$store.state.items[index].qty,
                unitprice: this.$store.state.items[index].unitprice,
                linedisc: this.$store.state.items[index].linedisc,
                location : this.$store.state.items[index].location,
                usercardid : this.$store.state.UserCardId.cardNo,
                PosId: this.$store.state.PosId,
                //dtoManual: this.$store.state.items[index].dtoManual
                dtoManual: 1
            }
            this.axios.post(this.ApiBaseUrl + 'Sales/GetSalesLinePrice',JSON.stringify(req),{headers: {"Content-Type": "application/json"}})
            .then((response) => {        
                var data = JSON.parse(response.data.body.res)                
                this.$store.commit('updItem', {index, data})                
            })
        },
        focusSearch(){
            this.$store.commit('setFocusSearch',true)
        },
        GetAvailable(index){
            var availReq =  {
                
                itemno: this.$store.state.items[index].itemno,
                variant: this.$store.state.items[index].variant
            }
            this.axios.post(this.ApiBaseUrl + 'ItemSearch/ItemAvailVariant',JSON.stringify(availReq),{headers: {"Content-Type": "application/json"}})
            .then((response) => {        
                //this.Available = JSON.parse(response.data.body.res)
                this.Available = response.data;
            })
        },
        LocationChange(item,index){
            var req =  {
                custId: this.$store.state.customer.id,
                itemno: this.$store.state.items[index].itemno,
                qty: this.$store.state.items[index].qty,
                unitprice: this.$store.state.items[index].unitprice,
                linedisc: this.$store.state.items[index].linedisc,
                location : item.location,
                usercardid : this.$store.state.UserCardId.cardNo,
                PosId: this.$store.state.PosId              
            }
            this.axios.post(this.ApiBaseUrl + 'Sales/GetSalesLinePrice',JSON.stringify(req),{headers: {"Content-Type": "application/json"}})
            .then((response) => {        
                var data = JSON.parse(response.data.body.res)
                this.$store.commit('updItem', {index, data})                
            })
        },
        validateState(ref) {        
        if (this.errors.has('LineDisc')) {
          return false
        }
        return null
      }
    },
    directives: {
        focus: {
            // directive definition
            inserted: function (el) {
            el.focus()
        }
    }
}
}
</script>
<style scoped>
#block_container
{
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    cursor: pointer;
}
#bloc1
{
    display: flex;
    font-size: 13px;
    white-space: normal;
    flex-direction: column;    
}
#bloc2
{
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 16px;
    text-align: right;
    white-space: nowrap;
}
#delbtn {
    background: 0 0;
    border: 1px solid transparent;
    padding: 12px 14px;
    color: #6692B0;
    min-width: 0;
}
#SalesLineBtn
{
    display:block;
}
#orig-price
{
    text-decoration:line-through;
}
.popover{
    max-width: 500px; 
}

</style>